export const PLAN_TYPES = {
  FREE: 'FREE',
  BASIC: 'BASIC',
  PRO: 'PRO',
  ENTERPRISE: 'ENTERPRISE',
};

export const DEFAULT_PLAN = PLAN_TYPES.FREE;

